import React from "react";
import { useSelector } from "react-redux";
import { selectEntitiesByFilters } from "../../../../shared/store/views/entityView";
import { ShortcutsFilter } from "../../../../shared/utils/entitiesFiltersUtils";
import { getKey } from "../../../../shared/utils/tabsUtils";
import { usePermission } from "../../../../shared/hooks/usePermission";
import ToolsList from "../../../../shared/components/features/toolsList/ToolsList";
import Popup from "../../../../shared/components/ui/popup/Popup";
import ContentsPopup from "../../../../shared/components/ui/popup/contentPopup/ContentPopup";
import iconsList from "../../../../shared/components/ui/icons/iconsList";
import classes from "./ShortcutsPopup.module.css";

const ShortcutsPopup = ({ onClose }) => {

    const { lang, texts } = useSelector(state => state.translate);
    const shortcuts = useSelector((state) => selectEntitiesByFilters(state, ShortcutsFilter));
    const hasPermission = usePermission();

    return (
        <Popup close={onClose} title={texts.Shortcuts} dropClass={classes.BackdropPopupClass}>
            <ContentsPopup className={classes.ContentsPopup} scrollDropClass={classes.ShortcutsScroll}>
                <div className={classes.ShortcutsPopup}>
                    <ToolsList
                        className={classes.ShortcutsList}
                        tools={shortcuts?.filter(s => !s?.conditionType || hasPermission(getKey(s?.key)))?.map(shortcut => ({ ...shortcut, name: shortcut.name?.[lang] }))}
                    />
                </div>
            </ContentsPopup>
        </Popup>
    );
};

export default ShortcutsPopup;
